import { isCapacitorNative } from '@/core/utils/capacitor.utils';

/**
 * iOS/Android Cap builds use web-only billing (App Store 3.1.3(f)).
 * No Stripe Checkout / Customer Portal / upgrade CTAs in the native shell.
 */
export function canPurchaseBillingInApp(): boolean {
  return !isCapacitorNative();
}
